export default {
  state: {
    report: "",
  },
};
